import api from '../utils/api';

export interface EmailConfigData {
  senderName: string;
  senderEmail: string;
  active: boolean;
  /** Read-only flag — the API key is environment-managed, never settable via API. */
  brevoApiKeyConfigured?: boolean;
}

const BASE_URL = '/email-config';

// Get email configuration
export const getEmailConfig = async (): Promise<EmailConfigData> => {
  
  try {
    const response = await api.get<EmailConfigData>(BASE_URL);
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update email configuration
export const updateEmailConfig = async (config: EmailConfigData): Promise<EmailConfigData> => {
  
  try {
    const response = await api.post<EmailConfigData>(BASE_URL, config);
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Toggle email configuration status
export const toggleEmailConfigStatus = async (): Promise<EmailConfigData> => {
  
  try {
    const response = await api.post<EmailConfigData>(`${BASE_URL}/toggle-status`);
    
    return response.data;
  } catch (error) {
    throw error;
  }
};
